import SKJ from "../src/images/CustomerLogo/1 Sri krishna jewellers.jpg";
import SKS from "../src/images/CustomerLogo/03 - SKS NITHYAM JEWELLERS logo Final - PNG.png";
import Aadhira from "../src/images/CustomerLogo/Aadhira Velli Maligai Logo.png";
import AJP from "../src/images/CustomerLogo/Aarthi Jewel Palace.png";
import AGS from "../src/images/CustomerLogo/ags.png";
import AJ from "../src/images/CustomerLogo/AJ Logo.PNG";
import AMR from "../src/images/CustomerLogo/AMR.png";
import ATM from "../src/images/CustomerLogo/Amrish Thanga Maligai.jpg";
import ANJ from "../src/images/CustomerLogo/ANJ.png.png";
import AS from "../src/images/CustomerLogo/AS Jewellers.jpg";
import AVM from "../src/images/CustomerLogo/AVM.jpg";
import Bairi from "../src/images/CustomerLogo/Bairi Gold Logo.png";
import CJ from "../src/images/CustomerLogo/Chakravarthy Jewellers logo.jpg";
import DJM from "../src/images/CustomerLogo/Dhana Jewellery Mart.jpg";
import DNJ from "../src/images/CustomerLogo/Dhananithi Jewellery.jpg";
import RJ from "../src/images/CustomerLogo/Final.jpg.jpg";
import AUM from "../src/images/CustomerLogo/Final Aum Jewellery logo.jpg";
import GJ from "../src/images/CustomerLogo/Geetha Jewellers.png";
import GST from "../src/images/CustomerLogo/Gomathi Shankar Thangamaligai.png.png";
import GR from "../src/images/CustomerLogo/GR Thanga Maligai.png";
import EJ from "../src/images/CustomerLogo/IMG_20250415_222436.jpg";
import IJ from "../src/images/CustomerLogo/ishwariyam logo.jpg";
import JMJ from "../src/images/CustomerLogo/Jaimaruthi.png";
import Jewere from "../src/images/CustomerLogo/Jewelre Logo Trans.png (1).png";
import JNR from "../src/images/CustomerLogo/JNR logo.png.png";
import JVS from "../src/images/CustomerLogo/JP Logo.jpg.jpg";
import JP from "../src/images/CustomerLogo/JP Thanga & Velli Maaligai.jpg";
import KT from "../src/images/CustomerLogo/Karthick Thangamaligai.png";
import KV from "../src/images/CustomerLogo/Kattlas Vellikada.jpg";
import KCD from "../src/images/CustomerLogo/KCD.jpg";
import KN from "../src/images/CustomerLogo/KN Jewellery.png";
import logo1 from "../src/images/CustomerLogo/logo1.png";
import SG from "../src/images/CustomerLogo/Logo 500x500 PNG (WO- BG).png.png";
import AJM from "../src/images/CustomerLogo/Logo 500x500 PNG (WO- BG).png (1).png";
import MGDM from "../src/images/CustomerLogo/Mahalaxmi.png";
import MJ from "../src/images/CustomerLogo/malan-jewellery.png";
import MCS from "../src/images/CustomerLogo/MCS Jewells.png.png";
import MKM from "../src/images/CustomerLogo/MKM English_00.png";
import NJ from "../src/images/CustomerLogo/Natesa Jewellery.png";
import NGD from "../src/images/CustomerLogo/Navamani Logo 1.jpg";
import OD from "../src/images/CustomerLogo/Oprea.jpg";
import PR from "../src/images/CustomerLogo/PR Logo With white BG.png.png";
import Radha from "../src/images/CustomerLogo/Radha.jpg";
import Raga from "../src/images/CustomerLogo/Raga Diamonds.png";
import Rajam from "../src/images/CustomerLogo/RAJAM jewellers.jpg";
import SJ from "../src/images/CustomerLogo/Saravanas Jewellers (2).png.png";
import SMSJ from "../src/images/CustomerLogo/Serr Mayuri Jewellers.jpg";
import SRN from "../src/images/CustomerLogo/Sibiraj Nagaimaaligai.png";
import SKJJ from "../src/images/CustomerLogo/SKJ.png";
import ST from "../src/images/CustomerLogo/Srinivasa Thangamaalihai.jpg";
import SSJ from "../src/images/CustomerLogo/Sri Swamy Jewellers Logo.png.png";
import SVJ from "../src/images/CustomerLogo/SRI VISHNU JEWELLERS.jpg";
import SSJI from "../src/images/CustomerLogo/SSJ.jpg";
import SSP from "../src/images/CustomerLogo/SSP.jpg";
import Subham from "../src/images/CustomerLogo/Subham Jewellery Eng.jpg";
import Sumangali from "../src/images/CustomerLogo/Sumangali.jpg";
import Swarna from "../src/images/CustomerLogo/Swarna Velli Jewels Logo.png.png";
import TRV from "../src/images/CustomerLogo/TRV.jpg";
import TVM from "../src/images/CustomerLogo/TVM logo.jpg";
import Valli from "../src/images/CustomerLogo/Valli Jewellers Logo 1.PNG";
import Velmurugan from "../src/images/CustomerLogo/Velmurugan Jewellery Logo Final 1.jpg";
import Venkateswara from "../src/images/CustomerLogo/Venkateswara.png";
import PMR from "../src/images/CustomerLogo/Venkateswara (PMR).png";
import VP from "../src/images/CustomerLogo/VP Logo.jpg";
import Vrindhavan from "../src/images/CustomerLogo/Vrindhavan Jewels.PNG";

const brand = [
  {
    Image: SKJ,
    title: "Sri Krishna Jewellery",
  },
  {
    Image: SKJJ,
    title: "SKJ Jewellers",
  },
  {
    Image: TRV,
    title: "TRV Jewellers",
  },
  {
    Image: TVM,
    title: "TVM Abarana Mahaal",
  },
  {
    Image: SKS,
    title: "SKS Nithyam Jewellery",
  },
  {
    Image: Aadhira,
    title: "Aadhira Velli Maaligai",
  },
  {
    Image: AJP,
    title: "Aarthi Jewel Palace",
  },
  {
    Image: AGS,
    title: "AGS Thanga maaligai",
  },
  {
    Image: AJ,
    title: "Akshara Jewellers",
  },
  {
    Image: AMR,
    title: "AMR Sumangalee Jewellers",
  },
  {
    Image: ATM,
    title: "Amrish Thanga maaligai",
  },
  {
    Image: ANJ,
    title: "Arunachala Nagarani Jewellery",
  },

  {
    Image: AS,
    title: "AS Jewellers",
  },
  {
    Image: AVM,
    title: "AVM Jewellers",
  },
  {
    Image: Bairi,
    title: "Bairi Gold Pvt Ltd",
  },
  {
    Image: CJ,
    title: "Chakravarthy jewellers",
  },
  {
    Image: DJM,
    title: "Dhana Jewellery Mart",
  },
  {
    Image: RJ,
    title: "Ravindran Jewellers Pvt Ltd",
  },
  {
    Image: AUM,
    title: "Sri Aum Jewellery",
  },
  {
    Image: ST,
    title: "Srinivasa Thangamaaligai",
  },
  {
    Image: GJ,
    title: "Geetha Jewellers",
  },
  {
    Image: Valli,
    title: "Valli Jewellers",
  },
  {
    Image: SVJ,
    title: "Sri Vishnu Jewellers",
  },
  {
    Image: EJ,
    title: "Eswar Jewellers",
  },
  {
    Image: Swarna,
    title: "Swarna Velli Jewels",
  },
  {
    Image: IJ,
    title: "Iswariyam Jewellery",
  },
  {
    Image: Velmurugan,
    title: "Velmurugan Jewellery",
  },
  {
    Image: JP,
    title: "JP Thanga & Velli Maaligai",
  },
  {
    Image: KV,
    title: "Kattlas Vellikada",
  },
  {
    Image: KN,
    title: "KN Jewellery",
  },
  {
    Image: logo1,
    title: "RR Jewellers",
  },
  {
    Image: SG,
    title: "Shavukaru Gold",
  },
  {
    Image: AJM,
    title: "Ajoras Jewellery Mart",
  },
  {
    Image: MGDM,
    title: "MGDM",
  },
  {
    Image: MJ,
    title: "Malan Jewellery",
  },
  {
    Image: MCS,
    title: "MCS Jewels",
  },
  {
    Image: NJ,
    title: "Natesa Jewellery",
  },
  {
    Image: NGD,
    title: "Navamani Gold & Diamonds",
  },
  {
    Image: OD,
    title: "Oprea Diamonds",
  },
  {
    Image: Radha,
    title: "RR Jewellers",
  },
  {
    Image: Raga,
    title: "Raga Diamond Jewels",
  },
  {
    Image: Rajam,
    title: "Rajam Jewellers",
  },
  {
    Image: SMSJ,
    title: "Sree Mayuri Silver Jewellery",
  },
  {
    Image: SRN,
    title: "Sibiraja Nagaimaaligai",
  },
  {
    Image: Subham,
    title: "Subham Jewellery",
  },
  {
    Image: Venkateswara,
    title: "Sree Venkateswara Jewellers",
  },
  {
    Image: PMR,
    title: "PMR Venkateswara Jewellery",
  },
  {
    Image: JVS,
    title: "JVS Jewellery",
  },
  {
    Image: SSJ,
    title: "Sri Swamy Jewellers",
  },
  {
    Image: KT,
    title: "Karthik Thangamaaligai",
  },
  {
    Image: SSP,
    title: "Salem Silver Palace",
  },
  {
    Image: SSJI,
    title: "SSJ India",
  },
  //New_client
  {
    Image: Sumangali,
    title: "Sumangali Jewellers",
  },
  {
    Image: VP,
    title: "VP Jewellery",
  },
  {
    Image: Vrindhavan,
    title: "Vrindhavan Jewellery",
  },
  {
    Image: MKM,
    title: "MKM Thangamaaligai",
  },
  {
    Image: JNR,
    title: "JNR Jewellery",
  },
  {
    Image: SJ,
    title: "Saravanas Jewellers",
  },
  {
    Image: PR,
    title: "PR Silver",
  },
  {
    Image: GST,
    title: "Gomathi Shankar Thangamaaligai",
  },
  {
    Image: GR,
    title: "GR Thangamaaligai",
  },
  {
    Image: KCD,
    title: "Karat & Carat",
  },
  {
    Image: DNJ,
    title: "Dhananithi Jewellery",
  },
  {
    Image: JMJ,
    title: "Jai Maruthi Jewellery",
  },
  {
    Image: Jewere,
    title: "JewelRE",
  },
];

export { brand };
